export default __webpack_public_path__ + "static/media/Thankyou.daa2c49c.svg";